import { injectable } from 'inversify';

import { IMatchesRepository } from '@/domain/repositories/matches.repository.interface';
import { Matches, Result, TeamLeaguePlayerInfo, TeamPlayerInfo } from '@/entities';
import {
	matchesDtoToMatches,
	teamPlayersDetailsDtoToTeamPlayersDetails,
	teamPlayersInfoDtoToTeamPlayersInfo
} from '@/infrastructure/mapper/matches-mapper';
import { getMatches, getTeamPlayers, getTeamPlayersInfo } from '@/infrastructure/network/data/matches';

@injectable()
export class MatchesRepository implements IMatchesRepository {
	async getMatchesByUuid(matchId: string): Promise<Result<Matches>> {
		const result = await getMatches({ matchId });
		if (result.statusCode === 200) {
			return {
				data: matchesDtoToMatches(result.data),
				statusCode: result.statusCode
			};
		} else {
			return { statusCode: result.statusCode, correlationId: result.correlationId, error: result.error };
		}
	}

	async getTeamPlayers(organizationUuid: string, teamLeagueUuid: string, teamUuid: string): Promise<Result<TeamPlayerInfo[]>> {
		const result = await getTeamPlayers({ organizationUuid, teamLeagueUuid, teamUuid });
		if (result.statusCode === 200) {
			return {
				data: teamPlayersInfoDtoToTeamPlayersInfo(result.data),
				statusCode: result.statusCode
			};
		} else {
			return { statusCode: result.statusCode, correlationId: result.correlationId, error: result.error };
		}
	}

	async getTeamPlayersInfo(
		organizationUuid: string,
		teamLeagueUuid: string,
		teamUuid: string,
		search: string
	): Promise<Result<TeamLeaguePlayerInfo[]>> {
		const response = await getTeamPlayersInfo({
			organizationUuid,
			teamLeagueUuid,
			teamUuid,
			search
		});

		if (response.statusCode === 200) {
			return {
				data: teamPlayersDetailsDtoToTeamPlayersDetails(response.data),
				statusCode: response.statusCode
			};
		} else {
			return {
				statusCode: response.statusCode,
				correlationId: response.correlationId,
				error: response.error
			};
		}
	}
}
